import script from "./GlobalFloatButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./GlobalFloatButton.vue?vue&type=script&lang=ts&setup=true"

import "./GlobalFloatButton.vue?vue&type=style&index=0&id=9353fb8e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9353fb8e"]])

export default __exports__